import { render, staticRenderFns } from "./SseDisplayScreenshot.vue?vue&type=template&id=2fcf7216&scoped=true"
import script from "./SseDisplayScreenshot.vue?vue&type=script&lang=js"
export * from "./SseDisplayScreenshot.vue?vue&type=script&lang=js"
import style0 from "./SseDisplayScreenshot.vue?vue&type=style&index=0&id=2fcf7216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf7216",
  null
  
)

export default component.exports